import { Injectable } from '@angular/core';
import { EnquiryService } from './enquiry.service';
import { mediaQueryServiceConfig } from './media-query.config';
import {useDefault} from '../common';

const LARGE_INDEX = 3;
const XS_ID = 'xs';

@Injectable()
export class MediaQueryService {
  private _viewport: {};
  private _orientation = '';
  private _photoWidth: number;

  constructor (private enquire: EnquiryService) {
    this.init();
  }

  photoWidth() {
    return this._photoWidth;
  }

  viewPort() {
    return this._viewport;
  }

  isExtraSmallViewPort() {
    return this.isViewPort(XS_ID);
  }

  get orientation(): string {
    return this._orientation;
  }

  isViewPort(viewPortId) {
    return useDefault(this._viewport, mediaQueryServiceConfig.viewports[LARGE_INDEX]).id === viewPortId;
  }

  init () {

    for (const viewport of mediaQueryServiceConfig.viewports) {
      const viewPortFunc = () => {
        this._viewport = viewport;
        this._photoWidth = viewport.photoWidth;
      };
      this.enquire.register(viewport.query, viewPortFunc);
    }

    for (const orientation of mediaQueryServiceConfig.orientations) {
      const orientationFunc = () => {
        this._orientation = orientation.id;
      };
      this.enquire.register(orientation.query, orientationFunc);
    }
  }
}






// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/common/media-query/media-query.service.ts